import { frontendURL } from '../../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import AgentConfigIndex from './Index.vue';
import AgentConfigEdit from './Edit.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-configs'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'agent_configs_index',
          meta: {
            permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          },
          component: AgentConfigIndex,
        },
        {
          path: 'new',
          name: 'agent_configs_new',
          meta: {
            permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          },
          component: AgentConfigEdit,
        },
        {
          path: ':agentConfigId/edit',
          name: 'agent_configs_edit',
          meta: {
            permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          },
          component: AgentConfigEdit,
        },
      ],
    },
  ],
};
